module.exports = __webpack_public_path__ + "static/media/img6.02295137.jpeg";